import { Trans, useTranslation } from 'react-i18next';

import { abbrNumber } from '@hotjar/insights-common/lib/number';
import { plural } from '@hotjar/insights-common/lib/plural';

export const TranslatedSessionCountsText = ({
  sessionCount,
  isAbbreviated,
}: {
  sessionCount: number;
  isAbbreviated?: boolean;
}): JSX.Element => {
  const { t } = useTranslation();

  if (isAbbreviated === true) {
    return (
      <>
        {`${abbrNumber(sessionCount)} ${plural(
          {
            one: t('heatmaps:session-counts.session-text'),
            other: t('heatmaps:session-counts.sessions-text'),
          },
          sessionCount,
        )}`}
      </>
    );
  }

  return (
    <Trans i18nKey="heatmaps:session-counts.number-of-sessions" count={sessionCount}>
      {{ sessionCount }} sessions
    </Trans>
  );
};
